import type { AgentUserConversation, Organization } from "@overmap-ai/common"
import type { Selector } from "@overmap-ai/core"

import type { RootState } from "../typings"

export const selectIsLoggedIn: Selector<RootState, boolean> = (state) => state.app.isLoggedIn

export const selectActiveAgentConversationId: Selector<RootState, AgentUserConversation["uuid"] | null> = (state) =>
	state.app.activeAgentConversationId

export const selectActiveOrganizationId: Selector<RootState, Organization["uuid"] | null> = (state) =>
	state.app.activeOrganizationId
